export default __webpack_public_path__ + "static/media/0_Still.c48a5e1d.jpg";